import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/api.service';
import { AppConstants } from 'src/app/app.constants';
import { aggressor } from 'src/app/models/aggressorModel';
import { FunctionsService } from 'src/app/services/functions.service';
// import { AppConstants } from 'src/app/shared/constants/app-constants';

@Component({
  selector: 'app-create-agressor',
  templateUrl: './create-agressor.component.html',
  styleUrls: ['./create-agressor.component.css']
})
export class CreateAggressorComponent implements OnInit {

  // addAggressorForm!: FormGroup;
  // formSubmitted = false;
  // picturePreview: string | ArrayBuffer | null = null;
  // profilePicture: File | null = null;
  // lang: string = 'en';
  
  // aggressor: aggressor;
  
  // // Date variables
  // currentDate = new Date();
  // startDate: Date | null = null;
  // endDate: Date | null = null;
  
  // // Route params
  // participantId: string;
  // aggressorId: string;         

  // // Determines form mode
  // get isEditMode(): boolean {
  //   return this.aggressorId != '';
  // }

  // constructor(
  //   private formBuilder: FormBuilder,
  //   private router: Router,
  //   private route: ActivatedRoute,
  //   private spinner: NgxSpinnerService,
  //   public translate: TranslateService,
  //   private apiService: ApiService
  // ) {
  //   this.lang = this.translate.currentLang;
  // }

    addAggressorForm!: FormGroup;
  formSubmitted = false;
  picturePreview: string | ArrayBuffer | null = null;
  profilePicture: File | null = null;
  lang: string = 'en';
  aggressor: aggressor;
  aggressorStatus: number = 1;
  
  // Date variables
  currentDate = new Date();
  startDate: Date | null = null;
  endDate: Date | null = null;
  
  // Route params
  participantId: string = '';
  aggressorId: string = '';
  currentAggressor: any = null;

  // Determines form mode
  get isEditMode(): boolean {
    return this.aggressorId !== '';
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    private apiService: ApiService,
    private functionsService: FunctionsService // Add this
  ) {
    this.lang = this.translate.currentLang;
  }

  // ngOnInit(): void {
  //   this.participantId = this.route.snapshot.paramMap.get('participantId');
  //   this.aggressorId   = this.route.snapshot.paramMap.get('aggressorId');
    
  //   this.initializeForm();
    
  //   // If edit mode, load existing aggressor data
  //   if (this.isEditMode) {
  //     this.loadAggressor();
  //   }
  // }

  ngOnInit(): void {
  // For nested routes like view-user/:id/aggressor, params are in parent
  this.participantId = this.route.snapshot.parent?.paramMap.get('id') || '';
  this.aggressorId   = this.route.snapshot.parent?.paramMap.get('aggressorId') || '';

  console.log('participantId from parent route:', this.participantId);
  console.log('aggressorId from parent route:', this.aggressorId);
  console.log('isEditMode:', this.isEditMode);

  this.initializeForm();

  if (this.isEditMode) {
    this.loadAggressor();
  }
}

  initializeForm(): void {
    this.addAggressorForm = this.formBuilder.group({
      aggressorName:            ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\s'-]+$/)]],
      aggressorPrimaryAddress:  ['', [Validators.required, Validators.maxLength(200)]],
      aggressorSecondaryAddress:['', Validators.maxLength(200)],
      protectionOrderNumber:    ['', [Validators.required, Validators.maxLength(50)]],
      protectionOrderStartDate: ['', Validators.required],
      protectionOrderEndDate:   ['', Validators.required],
      precint:                  ['', Validators.maxLength(100)],
      agent:                    ['', Validators.maxLength(100)], 
      restrictedArea:           ['', Validators.maxLength(200)]
    });
  }

  /**
   * Load existing aggressor data for edit mode
   */
  loadAggressor(): void {
    this.spinner.show();
    
    this.apiService.getAggressorById(this.aggressorId).subscribe({
      next: (aggressor) => {
        this.aggressor = aggressor;
        this.spinner.hide();
         this.aggressorStatus = aggressor.status;
        // Patch form with existing data
        this.addAggressorForm.patchValue({
          aggressorName:             aggressor.aggressorName,
          aggressorPrimaryAddress:   aggressor.aggressorPrimaryAddress,
          aggressorSecondaryAddress: aggressor.aggressorSecondaryAddress || '',
          protectionOrderNumber:     aggressor.protectionOrderNumber,
          protectionOrderStartDate:  new Date(aggressor.protectionOrderStartDate),
          protectionOrderEndDate:    new Date(aggressor.protectionOrderEndDate),
          precint:                   aggressor.precint || '',
          agent:                     aggressor.agent || '',
          restrictedArea:            aggressor.restrictedArea || ''
        });
        
        // Set date variables for datepicker min/max
        this.startDate = new Date(aggressor.protectionOrderStartDate);
        this.endDate   = new Date(aggressor.protectionOrderEndDate);
        
        // Show existing image preview if available
        if (aggressor.imageUrl) {
          this.picturePreview = aggressor.imageUrl;
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error loading aggressor:', error);
        alert(this.translate.instant('error.server_error'));
        this.router.navigate(['/main/users']);
      }
    });
  }

  // Getters for form controls
  get aggressorName()             { return this.addAggressorForm.get('aggressorName')!; }
  get aggressorPrimaryAddress()   { return this.addAggressorForm.get('aggressorPrimaryAddress')!; }
  get aggressorSecondaryAddress() { return this.addAggressorForm.get('aggressorSecondaryAddress')!; }
  get protectionOrderNumber()     { return this.addAggressorForm.get('protectionOrderNumber')!; }
  get protectionOrderStartDate()  { return this.addAggressorForm.get('protectionOrderStartDate')!; }
  get protectionOrderEndDate()    { return this.addAggressorForm.get('protectionOrderEndDate')!; }
  get precint()        { return this.addAggressorForm.get('precint')!; }
  get agent()          { return this.addAggressorForm.get('agent')!; }
  get restrictedArea() { return this.addAggressorForm.get('restrictedArea')!; }

  handleProfilePictureUploadOld(files: FileList): void {
    document.getElementById("doc-err")!.innerText = "";
    
    if (files.item(0)!.size > 5000000) {
      document.getElementById("doc-err")!.innerHTML = this.translate.instant('profile.img_upload_size_err');
      this.translate.onLangChange.subscribe(() => {
        document.getElementById("doc-err")!.innerHTML = this.translate.instant('profile.img_upload_size_err');
      });
    }
    // else if (AppConstants.imageFormats.includes(files.item(0)!.type)) {
    //   this.profilePicture = files.item(0);
    //   const reader = new FileReader();
    //   reader.onload = () => this.picturePreview = reader.result;
    //   document.getElementById("fileLabel")!.innerHTML = this.profilePicture!.name;
    //   reader.readAsDataURL(this.profilePicture!);
    // }
    else {
      document.getElementById("doc-err")!.innerText = this.translate.instant("error.image_format");
      this.translate.onLangChange.subscribe(() => {
        document.getElementById("doc-err")!.innerText = this.translate.instant("error.image_format");
      });
    }
  }

   /**
   * Handle profile picture upload - COPIED FROM ChangePictureComponent
   */
  handleProfilePictureUpload(files: FileList): void {
    if (files.item(0)) {
      document.getElementById("doc-err")!.innerText = "";
      
      if (files.item(0)!.size > 5000000) {
        document.getElementById("doc-err")!.innerHTML = this.translate.instant('profile.img_upload_size_err');
        this.translate.onLangChange.subscribe(() => {
          document.getElementById("doc-err")!.innerHTML = this.translate.instant('profile.img_upload_size_err');
        });
      }
      else if (AppConstants.imageFormats.includes(files.item(0)!.type)) {
        this.profilePicture = files.item(0);
        const reader = new FileReader();
        reader.onload = () => this.picturePreview = reader.result;
        document.getElementById("fileLabel")!.innerHTML = this.profilePicture!.name;
        reader.readAsDataURL(this.profilePicture!);
      }
      else {
        document.getElementById("doc-err")!.innerText = this.translate.instant("error.image_format");
        this.translate.onLangChange.subscribe(() => {
          if (document.getElementById("doc-err")!.innerText) {
            document.getElementById("doc-err")!.innerText = this.translate.instant("error.image_format");
          }
        });
      }
    }
  }

 
  addAggressorSave(): void {
  this.formSubmitted = true;
  document.getElementById('server_error')!.innerHTML = '';
  
  // if (this.addAggressorForm.invalid) {
  //   document.getElementById('server_error')!.innerHTML = this.translate.instant('error.fill_required_fields');
  //   return;
  // }
  
  this.spinner.show();

  var aggressorData: any;
  
  // if (this.isEditMode) {
  //   // EDIT mode - use the loaded aggressor object
  //   aggressorData = {
  //     ...this.aggressor,  // This includes all existing fields
  //     aggressorName:             this.addAggressorForm.value.aggressorName,
  //     aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
  //     aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
  //     protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
  //     protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
  //     protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate)
  //   };
  // } else {
  //   // CREATE mode - DON'T include id
  //   aggressorData = {
  //     participantId:             parseInt(this.participantId),
  //     aggressorName:             this.addAggressorForm.value.aggressorName,
  //     aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
  //     aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
  //     protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
  //     protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
  //     protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate),
  //     imageUrl: null
  //   };
  
  if (this.isEditMode) {
  // EDIT mode
  aggressorData = {
    ...this.aggressor,
    aggressorName:             this.addAggressorForm.value.aggressorName,
    aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
    aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
    protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
    protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
    protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate),
    // ✅ ADD NEW FIELDS
    precint:                   this.addAggressorForm.value.precint || null,
    agent:                     this.addAggressorForm.value.agent || null,
    restrictedArea:            this.addAggressorForm.value.restrictedArea || null
  };
} else {
  // CREATE mode
  aggressorData = {
    participantId:             parseInt(this.participantId),
    aggressorName:             this.addAggressorForm.value.aggressorName,
    aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
    aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
    protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
    protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
    protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate),
    // ✅ ADD NEW FIELDS
    precint:                   this.addAggressorForm.value.precint || null,
    agent:                     this.addAggressorForm.value.agent || null,
    restrictedArea:            this.addAggressorForm.value.restrictedArea || null,
    imageUrl: null
  };

  }

  // Create or Update based on mode
  const request$ = this.isEditMode
    ? this.apiService.updateAggressor(this.aggressorId, aggressorData)
    : this.apiService.createAggressor(aggressorData);
  
  request$.subscribe({
    next: (response) => {
      console.log('Aggressor saved successfully:', response);
      
      // IMAGE UPLOAD LOGIC HERE
      if (this.profilePicture) {
        // Get aggressor ID for image upload
        const aggressorIdForImage = this.isEditMode ? parseInt(this.aggressorId) : response.id;
        this.saveAggressorPicture(aggressorIdForImage);
      } else {
        // No image to upload, just redirect
        this.spinner.hide();
        this.router.navigate(['..'], { relativeTo: this.route });
      }
    },
    error: (error) => {
      this.spinner.hide();
      console.error('Error saving aggressor:', error);
      
      if (error.status === 409) {
        document.getElementById('server_error')!.innerHTML =
          this.translate.instant('aggressor.order_number_exists');
      } else {
        document.getElementById('server_error')!.innerHTML =
          error.error?.message || this.translate.instant('error.server_error');
      }
    }
  });
}

  /**
   * Save aggressor picture with resizing - COPIED FROM ChangePictureComponent
   */
  saveAggressorPicture(aggressorId: number): void {
    this.functionsService.resizeImage(this.profilePicture!, 600, 600).then(blob => {
      const file = new File([blob], "aggressor_image.jpg");
      
      this.apiService.uploadAggressorPicture(aggressorId, file).subscribe({
        next: (imageUrl) => {
          this.spinner.hide();
          console.log('Aggressor image uploaded successfully:', imageUrl);
          this.router.navigate(['/main/users/view-user', this.participantId]);
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Error uploading aggressor image:', error);
          // Aggressor saved but image failed - still redirect with warning
          // alert(this.translate.instant('aggressor.save_success_image_warning'));
          this.router.navigate(['/main/users/view-user', this.participantId]);
        }
      });
    }).catch(error => {
      this.spinner.hide();
      console.error('Error resizing image:', error);
      // alert(this.translate.instant('error.image_resize_failed'));
      // this.router.navigate(['/main/users/view-user', this.participantId]);
      this.router.navigate(['..'], { relativeTo: this.route });

    });
  }


  clearStartDate(): void {
    this.startDate = null;
    this.addAggressorForm.patchValue({ protectionOrderStartDate: '' });
  }

  clearEndDate(): void {
    this.endDate = null;
    this.addAggressorForm.patchValue({ protectionOrderEndDate: '' });
  }

  addAggressorSaveOld(): void {
    this.formSubmitted = true;
    document.getElementById('server_error')!.innerHTML = '';

    
    this.spinner.show();

    var aggressorData: any;

    if (this.isEditMode) {
  // EDIT mode - include id
  aggressorData = {
    ...this.aggressor,  // This includes the id
    aggressorName:             this.addAggressorForm.value.aggressorName,
    aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
    aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
    protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
    protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
    protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate)
  };
} else {
  // CREATE mode - DON'T include id
  aggressorData = {
    participantId:             parseInt(this.participantId), // Make sure it's number
    aggressorName:             this.addAggressorForm.value.aggressorName,
    aggressorPrimaryAddress:   this.addAggressorForm.value.aggressorPrimaryAddress,
    aggressorSecondaryAddress: this.addAggressorForm.value.aggressorSecondaryAddress || null,
    protectionOrderNumber:     this.addAggressorForm.value.protectionOrderNumber,
    protectionOrderStartDate:  this.formatDateForBackend(this.addAggressorForm.value.protectionOrderStartDate),
    protectionOrderEndDate:    this.formatDateForBackend(this.addAggressorForm.value.protectionOrderEndDate),
    imageUrl: null
    // NO id field here!
  };
}

    // Create or Update based on mode
    const request$ = this.isEditMode
      ? this.apiService.updateAggressor(this.aggressorId, aggressorData)
      : this.apiService.createAggressor(aggressorData);
    
    request$.subscribe({
      next: (response) => {
        this.spinner.hide();
        // alert(this.translate.instant(this.isEditMode ? 'aggressor.edit_success' : 'aggressor.add_success'));
        // this.router.navigate(['/main/users']);
        this.router.navigate(['..'], { relativeTo: this.route });

      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error saving aggressor:', error);
        
        if (error.status === 409) {
          document.getElementById('server_error')!.innerHTML =
            this.translate.instant('aggressor.order_number_exists');
        } else {
          document.getElementById('server_error')!.innerHTML =
            error.error?.message || this.translate.instant('error.server_error');
        }
      }
    });
  }

  formatDateForBackend(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    const year  = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day   = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00`;
  }

  onCancel(): void {
      this.router.navigate(['/main/users']);
  }
}